import { StyledContainer } from 'src/components/common/StyledComponents/Container';
import { StyledContainerInset } from 'src/components/common/StyledComponents/BackgroundContainer';
import { Notifications } from '@mantine/notifications';
import useResponsive from 'src/hooks/useResponsive';
import DynamicLayout from 'src/components/Layout/DynamicLayout';
import RegisterChildForm, {
  RegisterFormData,
} from 'src/components/Forms/Child/RegisterChild';
import ParentRegisterChildSidebar from 'src/components/Sidebars/Parent/ParentSidebarRegisterChild';
import useChildrenData from 'src/hooks/useChildrenData';
import { Text } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

const RegisterChildScreen = () => {
  const navigate = useNavigate();
  const { backgroundColor, backgroundColorExterior, isMobile, isDesktop } =
    useResponsive();
  const { children, createChild, deleteChild, loading } = useChildrenData();
  const [formError, setFormError] = useState<string | null>(null);
  // useViewportHeight()

  const header = (
    <div className='flex flex-col'>
      <Text size={'lg'} fw={'bold'}>
        Register Learner
      </Text>
      <Text className='hidden xl:flex' size={'md'}>
        Fill in the following details to register learner first.
      </Text>
    </div>
  );

  let heightStyle;
  if (isMobile) {
    // Is tablet or mobile (Max width 1024px)
    heightStyle = 'calc((var(--vh, 1vh) * 100) - 40px)';
  } else {
    // Desktop (Min width 1024px)
    heightStyle = 'calc((var(--vh, 1vh) * 100) - 70px)';
  }

  return (
    <DynamicLayout
      heading={header}
      SidebarComponent={ParentRegisterChildSidebar}
    >
      <StyledContainer theme={{ backgroundColor: backgroundColorExterior }}>
        <StyledContainerInset theme={{ backgroundColor: backgroundColor }}>
          <Notifications
            position={isMobile ? 'top-center' : 'bottom-right'}
            limit={isMobile ? 1 : 5}
          />
          <div
            style={{ height: heightStyle }}
            className='flex w-full mt-2 md:mt-5 xl:mt-0 md:items-center justify-center overflow-auto max-h-[calc(100dvh-55px-8px)] md:max-h-[calc(100dvh-80px)]'
          >
            <RegisterChildForm
              loading={loading}
              error={formError}
              setError={setFormError}
              onSubmit={async (values: RegisterFormData, cb = () => {}) => {
                try {
                  setFormError(null);
                  let temp = {
                    name: values.firstName + ' ' + values.lastName,
                    level: values.grade,
                    subjects: values.subjects,
                    username: values.username,
                    password: values.password,
                    school: values.school,
                    date_of_birth: `${values.birthYear}-01-01`,
                  };

                  const res = await createChild(temp, values.image);
                  console.log('res : ', res);
                  if (res === true) {
                    cb();
                    navigate(-1);
                  } else {
                    setFormError(
                      // res?.detail ||
                      'Failed to register learner. Please try again.'
                    );
                  }
                } catch (err) {
                  console.log('err : ', err);
                  setFormError(
                    err instanceof Error
                      ? err.message
                      : 'An error occurred while registering the learner.'
                  );
                }
              }}
            />
          </div>
        </StyledContainerInset>
      </StyledContainer>
    </DynamicLayout>
  );
};

export default RegisterChildScreen;
